export default __webpack_public_path__ + "static/crm-invoicing-balthazaurus-scroll-f63213355f3b8569146babbd3dfb269b.mp4";